import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(
  '06b153199f85f065d2875e5e279a03bfTz0xMTY2ODcsRT0xNzg1MDIzOTk5MDAwLFM9cHJlbWl1bSxMTT1wZXJwZXR1YWwsUFY9aW5pdGlhbCxLVj0y'
);
